<template>
  <v-app-bar
    color="rgba(0, 0, 0, 0.72)"
    fixed
    flat
  >
    <h1 class="headline">
      <span class="font-weight-black hidden-sm-and-down">
        VUETIFY
      </span>
      <span class="font-weight-light">
        MATERIAL KIT
      </span>
    </h1>
    <v-spacer />
    <v-btn
      text
      class="subheading mr-4 hidden-xs-only"
      color="primary"
    >
      Store
    </v-btn>
    <v-btn
      class="subheading"
      color="primary"
      href="https://store.vuetifyjs.com/product/material-kit-theme"
    >
      Buy Now
      <v-icon
        right
        dark
      >
        mdi-open-in-new
      </v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
  // Utilities
  import { mapMutations } from 'vuex'

  export default {
    name: 'Toolbar',

    data: () => ({
      items: []
    }),

    methods: {
      ...mapMutations('app', ['toggleDrawer'])
    }
  }
</script>
